import * as angular from 'angular';
import * as ngMessages from 'angular-messages';
import * as angularMessages from 'angular-messages';
import * as angularTranslate from 'angular-translate';
import * as uiTooltip from 'angular-ui-bootstrap/src/tooltip';
import * as angulartics from 'angulartics';

import { formValidationModule } from '../form-validation';
import { goLocalizeHelperModule } from 'go-modules/translation-helper';
import { richDropdownModule } from '../rich-dropdown';
import { goDateTimePickerModule } from '../datetimepicker';
import { activityEditor } from './activity-editor.component';
import { activityModel } from '../models/activity';
import { rubricTemplateModel } from '../models/rubric-template';
import { tagModel } from '../models/tag';
import { tagSetModel } from '../models/tag-set';
import { rubricEditorModalModule } from '../modals/rubric-editor';
import { uiDecimal } from '../ui-decimal';
import { activityInstructionsEditorModalModule } from '../modals/activity-instructions-editor';
import { goPopoverModule } from '../go-popover';
import { templates } from './templates';
import { helpUrlsModule } from '../help-urls';
import { markerSetPanelComponent } from './marker-set-panel';
import { rubricPanelComponent } from './rubric-panel';
import { instructionsPanelComponent } from './instructions-panel';
import { resourcesPanelComponent } from './resources-panel';
import { sourceMediaPanelComponent } from './source-media-panel';
import { aiMarkerSetPanelComponent } from './ai-marker-set-panel';

import 'angular-material/modules/js/input/input.css';
import './style.less';

// TODO: fix circular dependency.
// Until then, we need to import directly to force side-effect of angular module
// loading. If we leave the `fooModule from` part, webpack will use tree-shaking
// and the module will not be loaded.

import /*{ goModal } from*/ 'go-modules/modals';
import /*{ mediaThumbnailModule } from*/ '../media-thumbnail';
import /*{ activityAttachments } from*/ '../activity-attachments';
import { ngxMarkerDisplayModule } from '@go-modules/components/marker-display';
import { ngxGoModalServiceModule } from '@go-modules/services/go-modal';
import { ngxToolbarModule } from '@go-modules/components/toolbar';
import { ActivityEditorTourModule } from './activity-editor-tour';
import { SelectedModule } from 'go-modules/services/selected';
import { ActivityEditorAiMarkersTourModule } from './activity-editor-ai-markers-tour';
import { ActivityEditorDefaultMarkerSetTourModule } from './activity-editor-default-marker-set-tour';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';
import { ngxGoPulseTourServiceModule } from '@go-modules/services/go-pulse-tour';
import { ngxBadgeModule } from '@go-modules/components/badge';
import { ngxInstructionsPreviewDialogModule } from '@go-modules/components/dialogs/instructions-preview';
import { ngxPanelModule } from '@go-modules/components/panel';
import { ngxRequiredFieldsNoteModule } from '@go-modules/directives/required-fields-note';

export const activityEditorModule = angular.module('go.activity-editor', [
	uiDecimal,
	angularMessages,
	angularTranslate,
	uiTooltip,
	ngMessages,
	formValidationModule,
	richDropdownModule,
	goDateTimePickerModule,
	activityModel,
	rubricTemplateModel,
	tagModel,
	tagSetModel,
	rubricEditorModalModule,
	activityInstructionsEditorModalModule,
	angulartics,
	goPopoverModule,
	helpUrlsModule,
	goLocalizeHelperModule,
	ngxMarkerDisplayModule,
	ngxGoModalServiceModule,
	ngxToolbarModule,
	ngxBadgeModule,
	ActivityEditorTourModule,
	ngxGoPulseTourServiceModule,
	SelectedModule,
	ActivityEditorAiMarkersTourModule,
	ActivityEditorDefaultMarkerSetTourModule,
	ngxFeatureFlagServiceModule,
	ngxInstructionsPreviewDialogModule,
	ngxPanelModule,
	ngxRequiredFieldsNoteModule,

	// TODO: use module strings directly until circular dependency is fixed
	'go.modal',
	'go.mediaThumbnail',
	'go.activityAttachments'
])
	.run(templates)
	.component('activityEditor', activityEditor)
	.component('markerSetPanel', markerSetPanelComponent)
	.component('rubricPanel', rubricPanelComponent)
	.component('instructionsPanel', instructionsPanelComponent)
	.component('resourcesPanel', resourcesPanelComponent)
	.component('sourceMediaPanel', sourceMediaPanelComponent)
	.component('aiMarkerSetPanel', aiMarkerSetPanelComponent);
